<script setup lang="ts">
const props = defineProps<{
  error: any
}>()
</script>

<template>
  <div class="absolute flex min-h-screen w-full flex-col overflow-x-hidden">
    <AppError :error="props.error" />
  </div>
</template>
